import {
  GET_UTILITY_REQUEST_PROJECTS,
  GET_UTILITY_REQUEST_PROJECTS_SUCCESS,
  GET_UTILITY_REQUEST_PROJECTS_ERROR,
  GET_UTILITY_REQUEST_PROJECTS_EMPTY,
} from '../../actions.js';

const initialState = {
  data: null,
  loading: false,
  error: null,
};

const GetUtilityRequestProjects = (state = initialState, action) => {
  switch (action.type) {
    case GET_UTILITY_REQUEST_PROJECTS:
      return { ...state, loading: true };

    case GET_UTILITY_REQUEST_PROJECTS_SUCCESS:
      return { ...state, loading: false, data: action.payload };

    case GET_UTILITY_REQUEST_PROJECTS_ERROR:
      return { ...state, loading: false, error: action.payload };

    case GET_UTILITY_REQUEST_PROJECTS_EMPTY:
      return { ...initialState };

    default:
      return state;
  }
};

export default GetUtilityRequestProjects;
